import { template as _$template } from "solid-js/web";
import { use as _$use } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=shell__inset aria-hidden=true>`);
/**
 * The live aeroplane inside PERSONAL AIRCRAFT: a WebGPU canvas laid over the
 * well the 2D screen drew, tracking it through the shell's own letterbox
 * transform so it stays on the well at any window size.
 *
 * It is an overlay rather than something painted into the 320x200 frame because
 * the frame is a palette-indexed CPU surface — the original composited its 3D
 * viewer into the screen the same way, from a different renderer.
 */

import { createEffect, onCleanup } from "solid-js";
import { createAircraftPreview } from "./aircraft-preview.ts";
import "./aircraft-inset.css";
export function AircraftInset(props) {
  let host;
  let preview;
  onCleanup(() => {
    preview?.dispose();
    preview = undefined;
  });
  createEffect(() => {
    const box = props.box();
    if (!host) return;
    if (!box) {
      // Off the aircraft screen: keep the context (returning is common) but
      // take the canvas out of the layout entirely.
      host.style.display = "none";
      return;
    }
    const subject = props.surface.previewSubject();
    if (!subject) {
      host.style.display = "none";
      return;
    }
    host.style.display = "block";
    host.style.left = `${box.left}px`;
    host.style.top = `${box.top}px`;
    host.style.width = `${box.width}px`;
    host.style.height = `${box.height}px`;
    preview ??= createAircraftPreview(host);
    if (!preview) return;
    preview.resize(box.width, box.height);
    preview.show(subject.modelId, subject.paint);
    preview.setPose(subject.pose);
  });
  return (() => {
    var _el$ = _tmpl$();
    _$use(element => host = element, _el$);
    return _el$;
  })();
}